<template>
  <div>
    <CustomDropdown v-model="showDropdown" full-width>
      <template #trigger>
        <div class="px-2-5 py-2 d-flex align-items-center border-form rounded">
          <svg height="16" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.28601 26.5127H16.3758C18.3211 26.5127 19.6219 25.2706 19.6219 23.419V3.21582C19.6219 1.36426 18.3211 0.110352 16.3758 0.110352H3.28601C1.3407 0.110352 0.039917 1.36426 0.039917 3.21582V23.419C0.039917 25.2706 1.3407 26.5127 3.28601 26.5127ZM3.52039 24.626C2.51258 24.626 1.92664 24.0635 1.92664 23.1026V3.53223C1.92664 2.57129 2.51258 1.99707 3.52039 1.99707H16.1415C17.1376 1.99707 17.7352 2.57129 17.7352 3.53223V23.1026C17.7352 24.0635 17.1376 24.626 16.1415 24.626H3.52039Z" fill="#999999"/>
            <path d="M5.33679 10.9033H14.3368C14.9579 10.9033 15.3797 10.4931 15.3797 9.83691V7.30566C15.3797 6.64941 14.9579 6.23926 14.3368 6.23926H5.33679C4.71569 6.23926 4.29382 6.64941 4.29382 7.30566V9.83691C4.29382 10.4931 4.71569 10.9033 5.33679 10.9033ZM5.33679 20.3603H14.3368C14.9579 20.3603 15.3797 19.9384 15.3797 19.2939V16.7509C15.3797 16.1064 14.9579 15.6845 14.3368 15.6845H5.33679C4.71569 15.6845 4.29382 16.1064 4.29382 16.7509V19.2939C4.29382 19.9384 4.71569 20.3603 5.33679 20.3603Z" fill="#999999" />
          </svg>
      
          <p class="mb-0 body-2-4 mx-2-5 flex-shrink-0"><span class="text-subcolor body-2-1">Group by</span><span class="d-none d-md-inline"> : {{ selected.title }}</span></p>
          
          <svg class="delay" :class="{'transform-180' : showDropdown}" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.52769 8C6.7155 8 6.90325 7.92487 7.031 7.78212L12.8451 1.82535C12.9727 1.69765 13.0479 1.53239 13.0479 1.3446C13.0479 0.953987 12.7549 0.653519 12.3643 0.653519C12.1765 0.653519 12.0037 0.728637 11.876 0.848825L6.12205 6.7305H6.92581L1.17182 0.848825C1.05164 0.728637 0.878869 0.653519 0.683569 0.653519C0.292957 0.653519 0 0.953987 0 1.3446C0 1.53239 0.0751175 1.69765 0.202816 1.83286L6.01689 7.78212C6.15961 7.92487 6.33238 8 6.52769 8Z" fill="#999999"/>
          </svg>        
        </div>
      </template>

      <template #content>
        <div class="w-100 py-2">
          <div class="w-100 px-3 py-2 item-dropdown d-flex align-items-center justify-content-between cursor-pointer" v-for="item in list" @click="selectGroup(item)" :class="{'active': item.id === selected.id}">
            <p 
              class="mb-0" 
              :class="item.id === selected.id ? 'text-green body-2-4' : 'body-2-1'">{{ item.title }}</p>
            <svg v-if="item.id === selected.id" height="12" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.68676 20.7271C8.19067 20.7271 8.58911 20.5044 8.87036 20.0708L19.9445 2.6333C20.1555 2.29346 20.2375 2.03565 20.2375 1.76612C20.2375 1.12158 19.8156 0.699707 19.1711 0.699707C18.7023 0.699707 18.4445 0.852051 18.1633 1.29737L7.63989 18.0669L2.17895 10.9185C1.88598 10.5083 1.59302 10.3443 1.17114 10.3443C0.503174 10.3443 0.0461426 10.8013 0.0461426 11.4458C0.0461426 11.7154 0.163331 12.0201 0.385987 12.3013L6.46802 20.0474C6.81958 20.5044 7.18286 20.7271 7.68676 20.7271Z" class="fill-primary"/>
            </svg>
          </div>
        </div>
      </template>
    </CustomDropdown>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import CustomDropdown from '../../general/CustomDropdown.vue';

  export default {
    components:{
      CustomDropdown
    },
    data(){
      return{
        showDropdown: false,
        list: [
          { id: 'room_type', title: this.$t("hotel.rooms-type") },
          { id: 'promotion', title: this.$t("hotel.promotions") },
          { id: 'packages', title: this.$t("hotel.packages") },
        ],
        selected: {}
      }
    },
    computed:{
      ...mapGetters(['getBeSortBy'])
    },
    mounted(){
      this.selected = this.list.find(filter => filter.id === this.getBeSortBy);
    },
    methods:{
      ...mapMutations(['setBeSortBy']),
      selectGroup(selectedGroup){
        this.showDropdown = false
        if(this.selected.id === selectedGroup.id) return;

        this.selected = selectedGroup;
        this.setBeSortBy(selectedGroup.id)
        this.$emit('select');
        this.showDropdown = false
      }
    }
  }
</script>
<style>
.item-dropdown{
  transition: 0.1s;
}
.item-dropdown:hover, .item-dropdown.active{
  background-color: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/HotelRoomFilterGroupBy.vue